import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { TransitionContainerNoExit } from '../../components/Transition/TranstionContainer';

import { PeopleAnswered } from '../DefaultStyles/AssessmentDetails';
import { fillAnswerPercentage } from './PollAnimations';
import { copyFor, capitalization } from '../../copy/copy';

const Container = styled.div`
    width: 100%;
    background-color: #fafafa;
    padding: 20px;
`;

const QuestionText = styled.div`
    font-family: Averta;
    font-size: 16px;
    line-height: 1.28;
    color: #000000;
    font-weight: bold;
    text-align: left;
    margin: 0 0 6px 0;

    @media (max-width: 38em) {
        font-size: 14px;
        line-height: 1.2;
    }

    @media (max-width: 30em) {
        font-size: 16px;
        line-height: 1.28;
    }
`;

const Percentage = styled.div`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 50px;
    right: 12px;
    font-size: 12px;
    line-height: 1.22;
    font-weight: bold;
    text-align: right;

    @media (max-width: 35em) {
        right: 6px;
    }

    @media (max-width: 30em) {
        right: 12px;
    }
`;

const AnswerPercentage = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    animation: ${props => fillAnswerPercentage(props.percentage)} 750ms ease-in;
    width: ${props => props.percentage}%;
    height: 100%;
    border-radius: 4px 0 0 4px;
    background: ${props =>
        props.answerAnswered ? 'rgba(255, 36, 94, 0.5)' : 'rgba(255, 36, 94, 0.2)'};
`;

const AnswerText = styled.div`
    position: absolute;
    left: 12px;
    top: 0;
    top: 50%;
    transform: translateY(-50%);
    font-size: 12px;
    font-weight: bold;
    color: #000000;
    padding-right: 52px;
    line-height: 1.12;
    text-transform: ${props => (props.makeUppercase ? 'uppercase' : 'none')};
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 100%;

    @media (max-width: 35em) {
        padding-right: 38px;
        left: 6px;
    }

    @media (max-width: 30em) {
        font-size: 13px;
        padding-right: 54px;
        left: 12px;
        line-height: 1.1;
    }
`;

const AnswerContent = styled.div`
    width: calc(100% - 15px);
    height: ${props =>
        props.noOfAnswers === 4 ? '29px' : props.noOfAnswers === 3 ? '42px' : '50px'};
    margin: 0 8px;
    line-height: 100%;
    float: left;
    position: relative;
    border-radius: 4px;
    border: solid 1px #f1f1ee;
    margin-top: 10px;

    @media (max-width: 30em) {
        height: ${props =>
            props.noOfAnswers === 4 ? '44px' : props.noOfAnswers === 3 ? '62px' : '70px'};
    }

    @media (max-width: 22em) {
        height: ${props =>
            props.noOfAnswers === 4 ? '36px' : props.noOfAnswers === 3 ? '52px' : '60px'};
    }
`;

const AnswersWrapper = styled.div`
    float: left;
    width: calc(100% - 16px);
    position: absolute;
    left: 8px;
    bottom: 15px;
`;

const questionText = (questionText, noOfAnswers, isMobileResolution) => {
    if (!isMobileResolution) {
        const charLimit = noOfAnswers > 2 ? 64 : 120;
        if (questionText) {
            return questionText.length > charLimit
                ? questionText.substring(0, charLimit) + '...'
                : questionText;
        }
    }
    return questionText;
};

const PollSuccess = props => (
    <TransitionContainerNoExit zIndex={15}>
        <Container>
            <QuestionText noOfAnswers={props.results.length}>
                {questionText(
                    props.questionText,
                    props.noOfAnswers,
                    props.isMobileResolution
                )}
            </QuestionText>
            {props.isMobileResolution && (
                <PeopleAnswered textSize="small" topMargin="small">
                    {props.noOfPeopleAnswered}{' '}
                    {copyFor('miscellaneous', 'numAnswered', 'poll', capitalization.all)}
                </PeopleAnswered>
            )}
            <AnswersWrapper>
                {props.results.map(r => (
                    <AnswerContent key={r.id} noOfAnswers={r.noOfAnswers}>
                        <AnswerPercentage
                            percentage={r.percentage}
                            answerAnswered={r.answerAnswered}
                        />
                        <AnswerText noOfAnswers={r.noOfAnswers}>{r.text}</AnswerText>
                        <Percentage noOfAnswers={r.noOfAnswers}>
                            {r.percentage}%
                        </Percentage>
                    </AnswerContent>
                ))}
            </AnswersWrapper>
        </Container>
    </TransitionContainerNoExit>
);

PollSuccess.propTypes = {
    questionText: PropTypes.string.isRequired,
    results: PropTypes.array.isRequired,
    isMobileResolution: PropTypes.bool,
    noOfAnswers: PropTypes.number.isRequired,
    noOfPeopleAnswered: PropTypes.string.isRequired
};

export default connect(
    state => {
        return {
            isMobileResolution: state.widget.isMobileResolution
        };
    },
    {}
)(PollSuccess);
